// import {
//     SYSTEM_SETTING,
// } from '@/store/api/home';

const state = {
    latelySearchVal: '', // 最近搜索的参数
    hotTopicParam: {}, // 热门标签搜索的参数
    searchClickType: 'keyword'// OR 'topic'关键词搜索或标签搜索 用于高亮
};

const getters = {
};

const actions = {
    // requestLayoutData({ rootState }) {
    //     return rootState.app.$http.get(SYSTEM_SETTING, { loading: true });
    // }
    setLatelySearchVal({ commit }, param) {
        commit('SET_LATELY_SEARCH_VAL', param);
    },
    setHotTopicParam({ commit }, param) {
        commit('SET_HOT_TOPIC_PARAM', param);
    },
    setSearchClickType({ commit }, param) {
        commit('SET_SEARCH_CLICK_TYPE', param);
    },
};

const mutations = {
    SET_LATELY_SEARCH_VAL(mState, param) {
        mState.latelySearchVal = param;
    },
    SET_HOT_TOPIC_PARAM(mState, param) {
        mState.hotTopicParam = param;
    },
    SET_SEARCH_CLICK_TYPE(mState, param) {
        mState.searchClickType = param;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};

